/**
 * 1.3.0 the portal app's strings: the English catalogue from @prism/contracts (PORTAL_STRINGS, shared with the
 * emails), read through t(). Add strings in packages/contracts/src/portal-strings/<your stream>.ts, not here.
 */
export { PORTAL_STRINGS, t } from '@prism/contracts';
